/**
 * @param value
 * @returns {boolean}
 */
export const searchRibbonHideShow = (value) => {
    const container = document.querySelector('#searchFilterRibbon')
    if (container === null) {
      return false
    }
    const searchToggleBtn = document.querySelector('#toggle-search');
  
      const showHideSearchRibbon = (e) => {
          e.stopPropagation();       
          if($('#searchFilterRibbon').is(":hidden")){
            $('#searchFilterRibbon').css('display', 'block');
          }
          else{
            $('#searchFilterRibbon').css('display','none');
          }          
        }
  
        searchToggleBtn.addEventListener('click', (e) => showHideSearchRibbon(e))

}

export const refineFilterHideShow = (value) => {
  const container = document.querySelector('#refineFilter')
  if (container === null) {
    return false
  }
  const refineSearchToggleHed = document.querySelector('#refineFilterHideShow');

    const refineFilterHideShowEn = (e) => {
        e.stopPropagation();       
        if($('#refineFilter').is(":hidden")){
          $('#refineFilter').attr('style','display: block');;
        }
        else{
          $('#refineFilter').attr('style','display: none');;
        }          
      }

      refineSearchToggleHed.addEventListener('click', (e) => refineFilterHideShowEn(e))

}